<template>
  <div style="position: relative; width: 100%">
    <el-row>
      <el-col :span="24">
        <card title="Filtrar" subTitle="Por favor seleccione las opciones siguientes:">
          <hr class="mt-1">
          <el-row :gutter="20">
            <el-col :span="10">
              <label>Técnico</label>
              <el-select
                collapse-tags
                style="width: 100%"
                clearable
                multiple
                :multiple-limit="1"
                class="select-secondary required-technicians"
                v-model="model.technicians"
                filterable
                placeholder="Seleccione una o varios técnicos">
                <el-option v-for="(option, index) in technicians"
                            class="select-primary selected-all"
                            :value="option.technician"
                            :label="option.technician"
                            :key="index">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="10">
              <label>Fecha de Cierre</label>
              <el-date-picker
                v-model="rangeDate"
                clearable
                class="shadow-sm required-year"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="-"
                placeholder="Seleccione..."
                start-placeholder="Fecha Inicial"
                end-placeholder="Fecha Final">
              </el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-button type="info" style="margin-top: 26px" @click="filter">Filtrar...</el-button>
            </el-col>
          </el-row>
          <br>
        </card>
        <el-row
          v-if="tableData.length > 0"
          :gutter="20"
        >
          <el-col :span="6">
            <el-col :span="24">
              <stats-card v-bind:title="String(pki.total_success)" subTitle="Total Cerrados Exitosos">
              <div slot="header" class="icon-success">
                <em class="nc-icon nc-satisfied text-success"></em>
              </div>
              <template slot="footer">
                <em class="fa fa-calendar-o"></em> Ultimo actualización {{currentTime}}
              </template>
            </stats-card>
            </el-col>
          </el-col>
          <el-col :span="6">
            <el-col :span="24">
              <stats-card v-bind:title="String(pki.total_not_success)" subTitle="Cerrados No Exitosos">
              <div slot="header" class="icon-success">
                <em class="nc-icon nc-time-alarm text-danger"></em>
              </div>
              <template slot="footer">
                <em class="fa fa-calendar-o"></em> Ultimo actualización {{currentTime}}
              </template>
            </stats-card>
            </el-col>
          </el-col>
          <el-col :span="6" class="ml-5">
            <p style="font-size: 50px; font-weight: 800;" class="mb-1">{{pki.compliance}}%</p>
            <p style="font-size: 16px" class="ml-1">Cumplimiento</p>
          </el-col>
        </el-row>
        <br>
        <card
          v-if="tableData.length > 0"
        >
          <el-row>
            <el-col :span="24">
              <highcharts :options="chartOptions"></highcharts>
            </el-col>
          </el-row>
        </card>
        <br>
        <card
          v-if="tableData.length > 0"
          title="Tabla de Operaciones"
          subTitle="Operaciones realizadas en el filtro de fecha seleccionado"
        >
          <hr>
          <el-col :span="24" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por página"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              show-word-limit
              class="mb-3 shadow-sm"
              style="width: 200px"
              placeholder="Buscar registros"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </el-col>
          <el-col :span="24">
            <el-table
              stripe
              :default-sort="{prop: 'ticket', order: 'descending'}"
              style="width: 100%;"
              :data="queriedData"
              border
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
            </el-table>
          </el-col>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Table, TableColumn, Row, Col, Select, Option, Button } from "element-ui";
import { Pagination as LPagination } from "src/components/index";
import { Axios } from "src/custom_objetcs/Axios.js";
import {Chart} from 'highcharts-vue';
import moment from "moment";
import MixinDatePicker from "src/mixins/DatePicker.js";
import MixinHighChart from "src/mixins/Highchart.js";
import DataDashboardTable from "./DemoTables/DataDashboard1";
import Fuse from "fuse.js";
import {StatsCard} from 'src/components/index';

export default {
  components: {
    LPagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    highcharts: Chart,
    StatsCard
  },

  computed: DataDashboardTable.search,

  data() {
    return {
      model: {
        technicians: null
      },
      technicians: [],
      httpAxios: new Axios(this),
      searchQuery: "",
      tableData: [],
      fuseSearch: null,
      pagination: DataDashboardTable.table.pagination,
      tableColumns: DataDashboardTable.table.tableColumns,
      chartOptions: {},
      currentTime: moment().format('hh:mm:ss'),
      pki: {
        total_success: 0,
        total_not_success: 0,
        compliance: 0
      }
    };
  },

  mixins: [MixinDatePicker, MixinHighChart],

  methods: {
    filter() {
      if (this.model.technicians == null || this.model.technicians.length == 0) {
        return this.validationInputsRequired('-technicians')
      } else {
        this.$emit("cotentLoading", true);
        let data = {
          route: "filterbytechnicians",
          technicians: this.model.technicians,
          init: moment(this.rangeDate[0]).format("YYYY-MM-DD"),
          end: moment(this.rangeDate[1]).format("YYYY-MM-DD")
        };
        this.httpAxios.postMaster(data).then(success => {
          this.$emit("cotentLoading", false);
          this.tableData = success.data.table;
          this.chartOptions = this.spline(
            success.data.title,
            success.data.subtitle,
            success.data.xaxis,
            Object.values(Object.values(success.data.series)[0])
          )

          let totals = Object.values(success.data.totals)[0]
          this.pki.total_success = totals.total_success
          this.pki.total_not_success = totals.total_not_success
          this.pki.compliance = Math.round(((totals.total_success / (totals.total_success + totals.total_not_success)) * 100))

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map(column => {
              return column.prop;
            })
          });
        })
        .catch(error => {
          console.log(error);
          this.$emit("cotentLoading", false);
        });
      }
    },

    /**
    * @return {Promise}
    */
    async validationInputsRequired(reference) {
      return new Promise((resolve, reject) => {
        let elementsArray = document.getElementsByClassName('required' + reference)
        for (let key of elementsArray) {
          let inputsArray = key.getElementsByTagName('input')
          for (let index of inputsArray) {
            if (index.value.length == 0) {
              index.focus()
              index.classList.add("custom-has-error")
              this.removeHasError(index)
              reject(false)
            }
          }
        }
        resolve(true)
      })
    },

    async removeHasError(index) {
      if (index.classList.contains('el-input__inner'))
        setTimeout(() => {
          index.classList.remove('custom-has-error')
        }, 3000);
        return true
    },
  },

  created() {
    this.httpAxios.getMasters("technicians").then(success => {
      this.technicians = success.data;
    });
  }
};
</script>
<style>
</style>
